var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageHeader"},[(_vm.hasBackButton)?_c('Icon',{staticClass:"PageHeader__Icon",attrs:{"icon":"arrow-left"},on:{"click":_vm.handleClick}}):_vm._e(),_c('div',{staticClass:"PageHeader__Title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }